import React from 'react';
import { useTranslation } from 'react-i18next';
import { SuggestComboBox, SuggestComboBoxProps } from '../ComboBox/AbstractComboBox/SuggestComboBox';
import { TopUserResult } from '../ComboBox';
import { useHtmlValidId } from '../../../../../hooks/useHtmlValidId';
import getUserTopResults from '../ComboBox/User/getUserTopResults';
import ListItemPerson from '../ComboBox/AbstractComboBox/ListItemPerson/ListItemPerson';
import { FormsComboboxMultiSelectList } from '../FormsComboboxMultiSelect/partials/FormsComboboxMultiSelectList';
import { CategoriesParam } from '../../../../../_lib/Form2';
import { UserWithRolesSelectListItem } from './UserWithRolesSelectListItem';
import { useUserSelection } from './useUserSelection';
import { StateFacetItem } from '../../../ResultListSettings/ResultListSettings';
import SelectALot from '../SelectALot/SelectALot';
import { FormsComboboxMultiSelectListModifier } from '../FormsComboboxMultiSelect/partials/FormsComboboxMultiSelectList';

type RoleParamMulti = CategoriesParam<'roles'>;

export type UserWithRolesSelectMultiRoleProps = {
  idPrefix: string;
  roleParam: RoleParamMulti;
  suggestComboBoxProps: Omit<SuggestComboBoxProps<TopUserResult>, 'id' | 'onSelection' | 'validationMessage'>;
};

export function UserWithRolesSelectMultiRole({
  idPrefix,
  roleParam,
  suggestComboBoxProps,
}: UserWithRolesSelectMultiRoleProps) {
  const { t } = useTranslation('Members');
  const { selectedResults, addResult, removeResult } = useUserSelection();

  const id = useHtmlValidId();
  const headerLabelId = useHtmlValidId();

  return (
    <>
      <SuggestComboBox
        {...suggestComboBoxProps}
        name={undefined}
        id={`${idPrefix}select-combobox-${id}`}
        responseMapper={getUserTopResults}
        onSelection={(item: TopUserResult | undefined) => {
          addResult(item);
        }}
        validationMessage={
          suggestComboBoxProps.required && !selectedResults.length
            ? t('FormsComboBox:content.validationMessage')
            : undefined
        }
      >
        {item => <ListItemPerson user={item} />}
      </SuggestComboBox>
      {selectedResults && selectedResults.length > 0 && (
        <>
          <h3 className="invisible" id={headerLabelId}>
            {t('selectedPersons')}
          </h3>
          <FormsComboboxMultiSelectList
            labelId={headerLabelId}
            modifier={FormsComboboxMultiSelectListModifier.MARGIN_TOP}
          >
            {selectedResults.map((selectedResult, userId) => (
              <UserWithRolesSelectListItem
                key={selectedResult.id}
                selectedResult={selectedResult}
                removeResult={removeResult}
                userId={userId}
              >
                <SelectALot
                  name={`memberships[${userId}].roles`}
                  title={t('glossary:role_plural')}
                  items={roleParam.options as StateFacetItem[]}
                />
              </UserWithRolesSelectListItem>
            ))}
          </FormsComboboxMultiSelectList>
        </>
      )}
    </>
  );
}
